import request from '../utils/request';
import {url_host} from '../utils/comfig';
var _headers={
	"token":sessionStorage.getItem("access_token")
}
/**
 * 登录/用户管理
 */
//登录接口
export const Login = query => {
    return request({
        url: url_host+'/?s=Manage.Login.Login',
        method: 'post',
        data: query
    });
};
//角色名单
export const RoleList = query => {
    return request({
        url: url_host+'/?s=Manage.Login.RoleList',
        method: 'post',
        data: query
    });
};
//用户注册接口
export const Register = query => {
    return request({
        url: url_host+'/?s=Manage.Login.Register',
        method: 'post',
        data: query
    });
};

//用户列表
export const UserList = query => {
    return request({
        url: url_host+'/?s=Manage.User.UserList',
        method: 'post',
        data: query
    });
};

//用户删除
export const Delete = query => {
    return request({
        url: url_host+'/?s=Manage.User.Delete',
        method: 'post',
        data: query
    });
};

//用户停用
export const UpdateState = query => {
    return request({
        url: url_host+'/?s=Manage.User.UpdateState',
        method: 'post',
        data: query
    });
};

//用户详情
export const Detail = query => {
    return request({
        url: url_host+'/?s=Manage.User.Detail',
        method: 'post',
        data: query
    });
};

//修改用户信息接口
export const Update = query => {
    return request({
        url: url_host+'/?s=Manage.User.Update',
        method: 'post',
        data: query
    });
};

//部门列表
export const DepartmentList = query => {
    return request({
        url: url_host+'/?s=Manage.User.DepartmentList',
        method: 'post',
        data: query
    });
};

//新增版本接口
export const AddVersion = query => {
    return request({
        url: url_host+'/?s=Manage.Version.AddVersion',
        method: 'post',
        data: query
    });
};

//删除版本接口
export const DeleteVersion = query => {
    return request({
        url: url_host+'/?s=Manage.Version.DeleteVersion',
        method: 'post',
        data: query
    });
};

//版本管理列表接口
export const VersionList = query => {
    return request({
        url: url_host+'/?s=Manage.Version.VersionList',
        method: 'post',
        data: query
    });
};



// WEBPACK FOOTER //
// ./src/api/user_api.js